import i18n from 'i18nextInstance';
import moment from 'moment';
import { parseCampaignType } from 'core/Campaign';

export const HEADERS = [{
    accessor: parseCampaignType,
    key: 'type',
    label: i18n.t('Tipo')
}, {
    key: 'parsedName',
    label: i18n.t('Campaña')
}, {
    accessor: value => !value ? '-' : moment(value).format('DD/MM/YYYY'),
    key: 'parsedDatetime',
    label: i18n.t('Fecha de realización')
}];
